import axios from 'axios';

// 配置超时时间
axios.defaults.timeout = 300000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

axios.interceptors.response.use(
  (response) =>
    // console.log(response);
    // eslint-disable-next-line implicit-arrow-linebreak
    Promise.resolve(response),
  (error) =>
    // 失败请求的状态码
    // console.log(error);
    // eslint-disable-next-line implicit-arrow-linebreak
    Promise.reject(error.response.data)
  ,
);


class http {
  // eslint-disable-next-line consistent-return
  static async get(url, data) {
    try {
      let res = await axios.get(url, { params: data });
      res = res.data;
      return new Promise((resolve, reject) => {
        if (res != null) {
          resolve(res);
        } else {
          reject(res);
        }
      });
    } catch (err) {
      // console.log(err);
    }
  }

  // eslint-disable-next-line consistent-return
  static async post(url, data) {
    try {
      let res = await axios.post(url, data);
      res = res.data;
      return new Promise((resolve, reject) => {
        if (res != null) {
          resolve(res);
        } else {
          reject(res);
        }
      });
    } catch (err) {
      // console.log(err);
    }
  }
}

export default http;
